module.exports = __webpack_public_path__ + "img/QRM-03.cb9d223d.png";